export const buildActaInterviewedData = (visit: any) => {
    const empleadoSiniestro = visit?.siniestro?.empleado;

    return {
        entrevistado: {
            nombre:
                visit?.nombreEntrevistado ??
                visit?.entrevistado?.nombre ??
                empleadoSiniestro?.nombreCompleto ??
                '',
            dni:
                visit?.dniEntrevistado ??
                visit?.entrevistado?.dni ??
                empleadoSiniestro?.cuil ??
                '',
            caracter: visit?.caracterEntrevistado ?? visit?.entrevistado?.caracter ?? '',
            telefono: visit?.telefonoEntrevistado ?? visit?.entrevistado?.telefono ?? '',
            email: visit?.emailEntrevistado ?? visit?.entrevistado?.email ?? ''
        }
    };
};
